import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Secuencia/editSecuencia`, method: 'POST', body: values, token: token})
}